<div class="mt-[0px] m-[30px] pt-[20px] p-[25px] rounded-lg wrapper">
  <div class="flex justify-between">
    <div class="flex flex-col items-end">
      <div class="flex flex-col" *ngIf="editField !== 'projectTitle'">
        <div class="flex">
          <button
            (click)="handleClose()"
            class="hover:bg-gray-100 rounded w-[1rem] h-[1rem] mt-[0.5rem] ml-[-25px] mr-[10px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="11"
              viewBox="0 0 12 11"
              fill="none"
            >
              <path
                d="M4.84359 5.49767L9.33276 9.61293C9.45637 9.72597 9.52437 9.87711 9.52437 10.0383C9.52437 10.1995 9.45637 10.3506 9.33276 10.4638L8.93939 10.8242C8.81598 10.9376 8.651 11 8.4752 11C8.29939 11 8.13461 10.9376 8.0111 10.8242L2.66603 5.92462C2.54203 5.81104 2.47412 5.65928 2.47461 5.49794C2.47412 5.33589 2.54193 5.18431 2.66603 5.07064L8.00612 0.175822C8.12964 0.0624237 8.29442 0 8.47032 0C8.64612 0 8.8109 0.0624237 8.93451 0.175822L9.32778 0.536228C9.58368 0.770805 9.58368 1.15268 9.32778 1.38716L4.84359 5.49767Z"
                fill="black"
              />
            </svg>
          </button>
          <h3 class="!m-0 title-value">{{ projectData?.name }}</h3>
        </div>
        <div class="flex justify-start">
          <div class="title">Project Title</div>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] cursor-pointer"
            (click)="handleSelectField('projectTitle')"
          />
        </div>
      </div>
      <div *ngIf="editField === 'projectTitle'">
        <app-input-field
          [title]="'Project Title'"
          [placeholder]="'Enter Project Title'"
          [value]="projectData?.name"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>
    </div>
    <div class="flex">
    <div>
      <img
        src="assets/images/logo.png"
        alt="logo"
        class="h-[78px] w-[78px] rounded-[7px]"
      />
    </div>
  </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%] mt-[34px]">
    <div class="w-[30%] px-[30px] py-[20px] project-attributes-container">
      <p class="site-condition">Intro</p>
      <div *ngIf="editField !== 'projectType'">
        <div class="flex justify-start items-center">
          <p class="project-attribute">Project Type</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('projectType')"
          />
        </div>
        <p class="project-attribute-value">
          {{
            projectData?.project_type?.parent
              ? projectData?.project_type?.parent?.name
              : projectData?.project_type?.name
          }}
        </p>
      </div>
      <div *ngIf="editField === 'projectType'">
        <app-view-mode-project-type
          [projectType]="
            projectData?.project_type?.parent
              ? projectData?.project_type?.parent?.name
              : projectData?.project_type?.name
          "
          [projectTypeId]="projectData?.project_type?.parent?.id"
          [projectSubType]="projectData?.project_type?.name"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        >
        </app-view-mode-project-type>
      </div>
      <div
        *ngIf="editField !== 'projectType' && projectData?.project_type?.parent"
      >
        <div class="flex justify-start items-center">
          <p class="project-attribute">Project Sub Type</p>
        </div>
        <p class="project-attribute-value">
          {{ projectData?.project_type?.name }}
        </p>
      </div>
    </div>
    <div class="w-[70%] flex flex-col justify-center">
      <div class="flex justify-start items-baseline">
        <p class="brief">Brief</p>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
          (click)="handleSelectField('brief')"
          *ngIf="editField !== 'brief'"
        />
        <div *ngIf="editField === 'brief'">
          <div class="w-[100%] flex justify-start ml-[10px] mb-[5px]">
            <div class="flex justify-start">
              <div
                class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
              >
                <img
                  src="assets/icons/close.svg"
                  alt="close"
                  class="cursor-pointer w-[14px]"
                  (click)="cancel()"
                />
              </div>
              <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
                <img
                  src="assets/icons/save.svg"
                  alt="save"
                  class="cursor-pointer w-[20px] pr-[2px]"
                  (click)="onSave(projectBrief)"
                />
              </div>
            </div>
          </div>

          <app-rich-textEditor
            (contentChange)="addProjectBrief($event)"
            [resetEditor]="resetRichTextEditor"
            [richTextValue]="projectData?.description"
          ></app-rich-textEditor>
        </div>
      </div>

      <p
        *ngIf="editField !== 'brief'"
        class="brief-value"
        [innerHTML]="getSanitizedHtml(projectData?.description)"
      ></p>
    </div>
  </div>

  <div
    class="flex justify-start items-start gap-[50px] w-[100%] mt-[34px]"
  >
    <div class="w-[29%] p-[30px] pt-[0px]">
      <p class="site-condition">Location and Site Conditions</p>

      <div class="mt-[12px]">
        <div class="flex justify-start items-center">
          <p class="project-attribute">Country</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('country')"
            *ngIf="editField !== 'country'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'country'">
          {{ projectData?.country?.name }}
        </p>
      </div>
      <div *ngIf="editField === 'country'">
        <div class="w-[100%] flex justify-end mb-[5px]">
          <div class="flex justify-start">
            <div
              class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[100%] flex justify-end items-center"
            >
              <img
                src="assets/icons/close.svg"
                alt="close"
                class="cursor-pointer w-[16px]"
                (click)="onCLose()"
              />
            </div>
            <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[100%]">
              <img
                src="assets/icons/save.svg"
                alt="save"
                class="cursor-pointer w-[20px] pr-[2px]"
                (click)="onSave(updatedCountryId)"
              />
            </div>
          </div>
        </div>
        <app-country
          class="w-[100%]"
          [country]="projectData?.country?.name"
          (changeCountry)="updateCountry($event)"
        ></app-country>
      </div>

      <div class="mt-[12px]">
        <div class="flex justify-start items-center">
          <p class="project-attribute" *ngIf="editField !== 'city'">City</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('city')"
            *ngIf="editField !== 'city'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'city'">
          {{ projectData?.city }}
        </p>
      </div>
      <div *ngIf="editField === 'city'">
        <app-input-field
          [title]="'City'"
          [placeholder]="'Enter City'"
          [value]="projectData?.city"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>

      <div class="mt-[12px]">
        <div class="flex justify-start items-center">
          <p class="project-attribute" *ngIf="editField !== 'zipCode'">
            Zip Code
          </p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('zipCode')"
            *ngIf="editField !== 'zipCode'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'zipCode'">
          {{ projectData?.zip }}
        </p>
      </div>
      <div *ngIf="editField === 'zipCode'">
        <app-input-field
          [title]="'Zip code'"
          [placeholder]="'Enter Zip code'"
          [value]="projectData?.zip"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>

      <div class="mt-[12px]">
        <div class="flex justify-start items-center">
          <p class="project-attribute" *ngIf="editField !== 'street'">Street</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('street')"
            *ngIf="editField !== 'street'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'street'">
          {{ projectData?.street }}
        </p>
      </div>
      <div *ngIf="editField === 'street'">
        <app-input-field
          [title]="'Street'"
          [placeholder]="'Enter Street'"
          [value]="projectData?.street"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>

      <div class="mt-[12px]">
        <div class="flex justify-start items-center">
          <p class="project-attribute" *ngIf="editField !== 'latitude'">
            Latitude
          </p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('latitude')"
            *ngIf="editField !== 'latitude'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'latitude'">
          {{ projectData?.latitude }}
        </p>
      </div>
      <div *ngIf="editField === 'latitude'">
        <app-input-field
          [title]="'Latitude'"
          [placeholder]="'Enter Latitude'"
          [value]="projectData?.latitude"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>

      <div>
        <div class="flex justify-start items-center">
          <p class="project-attribute" *ngIf="editField !== 'longitude'">
            Longitude
          </p>
          <img
            *ngIf="editField !== 'longitude'"
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('longitude')"
          />
        </div>
        <p
          class="project-attribute-value !mb-[0px]"
          *ngIf="editField !== 'longitude'"
        >
          {{ projectData?.longitude }}
        </p>
      </div>
      <div *ngIf="editField === 'longitude'">
        <app-input-field
          [title]="'Longitude'"
          [placeholder]="'Enter Longitude'"
          [value]="projectData?.longitude"
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
        ></app-input-field>
      </div>
    </div>

    <div class="flex-1 flex items-start">
      <div class="flex flex-col">
        <div class="flex justify-start items-baseline">
          <p class="brief">Site Conditions</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] cursor-pointer"
            (click)="handleSelectField('siteCondition')"
            *ngIf="editField !== 'siteCondition'"
          />
        </div>
        <div *ngIf="editField === 'siteCondition'">
          <div class="w-[100%] flex justify-start ml-[10px] mb-[5px]">
            <div class="flex justify-start">
              <div
                class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
              >
                <img
                  src="assets/icons/close.svg"
                  alt="close"
                  class="cursor-pointer w-[14px]"
                  (click)="cancel()"
                />
              </div>
              <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
                <img
                  src="assets/icons/save.svg"
                  alt="save"
                  class="cursor-pointer w-[20px] pr-[2px]"
                  (click)="onSave(projectSiteCondition)"
                />
              </div>
            </div>
          </div>

          <app-rich-textEditor
            (contentChange)="addProjectSiteCondition($event)"
            [resetEditor]="resetRichTextEditor"
            [richTextValue]="projectData?.site_conditions"
          ></app-rich-textEditor>
        </div>
        <p
          *ngIf="editField !== 'siteCondition'"
          class="brief-value"
          [innerHTML]="getSanitizedHtml(projectData?.site_conditions)"
        ></p>
      </div>
    </div>
    <div class="flex-1 flex items-center">
      <iframe
        width="100%"
        height="244px"
        style="border: 0"
        loading="lazy"
        [src]="mapLink"
      >
      </iframe>
    </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%] mt-[20px]">
    <div class="w-[29%]"></div>

    <div class="flex-1 flex items-center">
      <div class="">
        <div class="flex justify-start items-center">
          <p class="site-images">Site images</p>
          <img
            *ngIf="editField !== 'siteImages'"
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleImagesSelect('siteImages')"
          />
        </div>
        <!-- isImagesEdit -->
        <app-gallery
          [uploadedFiles]="uploadedFiles"
          [isEdit]="isImagesEdit"
          (onSave)="onSave($event)"
          (onCLose)="onCLose()"
        ></app-gallery>
        <div class="flex justify-start items-center">
          <p class="site-images !mt-[18px]">Documents</p>
          <img
            *ngIf="editField !== 'documents'"
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleDocumentsSelect('documents')"
          />
        </div>
        <!-- isDocumentsEdit -->
        <app-gallery
          [uploadedFiles]="DocumentFiles"
          [isEdit]="isDocumentsEdit"
          (onSave)="onSave($event)"
          (onCLose)="onCLose()"
        ></app-gallery>
      </div>
    </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%] mt-[20px] min-h-[228px]">
    <div class="w-[29%] p-[30px] project-attributes-container">
      <div class="flex justify-start">
        <div class="key-deliverable">Key Deliverables</div>

        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
          (click)="handleSelectField('keyDeliverable')"
          *ngIf="editField !== 'keyDeliverable'"
        />
      </div>
    </div>

    <div class="flex-1 flex items-start mt-[30px]">
      <ul class="!pl-0" *ngIf="editField !== 'keyDeliverable'">
        <div *ngFor="let keyword of projectData?.goals" class="flex">
          <div class="flex">
            <span class="h-[22px] mr-[10px]">{{ keyword.name }}</span>
          </div>
        </div>
      </ul>
      <div *ngIf="editField === 'keyDeliverable'">
        <app-key-deliverable
          (onSave)="onSave($event)"
          (onCLose)="onCLose()"
          [keyDeliverable]="projectData?.goals"
        ></app-key-deliverable>
      </div>
    </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
    <div class="w-[29%] p-[30px]">
      <div class="key-deliverable mb-[6px]">Budget</div>
      <div *ngIf="editField !== 'grade'">
        <div class="flex justify-start items-center">
          <p class="project-attribute">Grade</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('grade')"
          />
        </div>
        <p class="project-attribute-value">{{ projectData?.grade?.name }}</p>
      </div>
      <div *ngIf="editField === 'grade'">
        <app-stage1-view-grade
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
          [selectedGradeId]="projectData?.grade?.id"
          [selectedGradeName]="projectData?.grade?.name"
        ></app-stage1-view-grade>
      </div>

      <!-- GMP Checkbox -->
      <div class="flex justify-start items-center">
        <p class="project-attribute">GMP Enabled</p>

        <img
          *ngIf="projectData?.budget && projectData?.budget?.amount"
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] h-[12px] cursor-pointer"
          (click)="handleSelectField('gmp')"
        />
      </div>

      <div>
        <div
          *ngIf="editField === 'gmp'"
          class="w-[100%] flex justify-start mb-[5px] mt-[8px]"
        >
          <div class="flex justify-start">
            <div
              class="ml-[12px] !bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[100%] flex justify-end items-center"
            >
              <img
                src="assets/icons/close.svg"
                alt="close"
                class="cursor-pointer w-[16px]"
                (click)="cancel()"
              />
            </div>
            <div class="ml-[12px] !bg-[#f9dacf] p-[4px] rounded-[100%]">
              <img
                src="assets/icons/save.svg
              "
                alt="save"
                class="cursor-pointer w-[16px] !pr-[2px]"
                (click)="save()"
              />
            </div>
          </div>
        </div>

        <div>
          <div>
            <input
              class="w-[1.1875rem] h-[1.25rem] rounded-[0.1875rem] mt-[0.25rem] cursor-pointer"
              type="checkbox"
              [checked]="projectData?.budget ? projectData?.budget?.gmp : false"
              [disabled]="editField === 'gmp' ? false : true"
              formControlName="gmpCheck"
              (change)="onGmpCheckChange($event)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1 flex flex-col items-start w-[100%]">
      <div class="w-[80%]">
        <div class="flex justify-between flex-col">
          <!-- Total Allocated Amount -->
          <div class="flex justify-between items-center">
            <div>
              <div class="mt-[12px]">
                <div class="flex justify-start items-center">
                  <p class="milestone-header">Total Allocated</p>
                  <img
                    src="assets/icons/pencil.svg"
                    alt="pencil"
                    class="ml-[10px] h-[12px] cursor-pointer"
                    (click)="handleSelectField('totalAllocated')"
                    *ngIf="editField !== 'totalAllocated'"
                  />
                </div>

                <p class="milestone-value !mb-[10px]" *ngIf="editField !== 'totalAllocated'">
                  {{ projectData?.budget ? projectData?.country?.symbol : "--" }}
                  {{ projectData?.budget ? (projectData.budget.amount | number: '1.0-0') : "" }}
                </p>
                
              </div>
              <div *ngIf="editField === 'totalAllocated'">
                <app-input-field
                  [title]="'Total Allocated'"
                  [placeholder]="'Enter Total Allocated'"
                  [isCurrencyField]="true"
                  [country]="projectData?.country"
                  [value]="
                    projectData?.budget ? projectData?.budget.amount : ''
                  "
                  (onCLose)="onCLose()"
                  (onSave)="onSave($event)"
                ></app-input-field>
              </div>
            </div>
            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-value !mb-[10px]">
                  <ng-container>
                    {{
                      projectData?.budget && projectData?.budget.amount
                        ? (numberToWords(projectData?.budget.amount)
                          | titlecase)
                        : ""
                    }}
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
          <!-- Risk and Contigency Amount -->
          <div
            *ngIf="
              projectData?.budget &&
              projectData?.budget.risk_and_contengency_amount &&
              projectData?.budget?.gmp
            "
            class="flex justify-between items-center"
          >
            <div>
              <div class="mt-[12px]">
                <div class="flex justify-start items-center">
                  <p class="milestone-header">Risk & Contingency</p>
                  <img
                    src="assets/icons/pencil.svg"
                    alt="pencil"
                    class="ml-[10px] h-[12px] cursor-pointer"
                    (click)="handleSelectField('risk&contingency')"
                    *ngIf="editField !== 'risk&contingency'"
                  />
                </div>

                <p
                  class="milestone-value !mb-[10px]"
                  *ngIf="editField !== 'risk&contingency'"
                >
                  {{ projectData?.country?.symbol }}
                  {{ projectData?.budget.risk_and_contengency_amount | number: '1.0-0' : ""  }}
                </p>
              </div>
              <div *ngIf="editField === 'risk&contingency'">
                <app-input-field
                  [title]="'Total risk & contingency'"
                  [placeholder]="'Enter total risk & contingency'"
                  [isCurrencyField]="true"
                  [country]="projectData?.country"
                  [value]="projectData?.budget.risk_and_contengency_amount"
                  (onCLose)="onCLose()"
                  (onSave)="onSave($event)"
                ></app-input-field>
              </div>
            </div>

            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-value !mb-[10px]">
                  <ng-container
                    *ngIf="
                      projectData?.budget.risk_and_contengency_amount &&
                      projectData?.budget.risk_and_contengency_amount
                    "
                  >
                    {{
                      numberToWords(
                        projectData?.budget.risk_and_contengency_amount
                      ) | titlecase
                    }}
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
          <!-- GMP Amount -->
          <div
            *ngIf="
              projectData?.budget &&
              projectData?.budget.gmp_amount &&
              projectData?.budget?.gmp
            "
            class="flex justify-between items-center"
          >
            <div>
              <p class="milestone-header">GMP Amount</p>
              <p class="milestone-value !mb-[10px]">
                {{ projectData?.country?.symbol }}
                {{ projectData?.budget.gmp_amount | number: '1.0-0' : "" }}
              </p>
            </div>

            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-value !mb-[10px]">
                  <ng-container
                    *ngIf="
                      projectData?.budget && projectData?.budget.gmp_amount
                    "
                  >
                    {{
                      numberToWords(projectData?.budget.gmp_amount) | titlecase
                    }}
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
    <div class="w-[29%] p-[30px] project-attributes-container">
      <div class="key-deliverable mb-[6px]">Milestones</div>
      <div>
        <div class="flex justify-start items-center">
          <p class="project-attribute">Project Start Date</p>
          <img
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('startDate')"
            *ngIf="editField !== 'startDate'"
          />
        </div>
        <p class="project-attribute-value" *ngIf="editField !== 'startDate'">
          {{ projectData?.start_date | date : "yyyy-MM-dd" }}
        </p>
      </div>
      <div *ngIf="editField === 'startDate'">
        <app-date
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
          [date]="projectData?.start_date"
        ></app-date>
      </div>

      <div>
        <div class="flex justify-start items-center">
          <p class="project-attribute">Project End Date</p>
          <img
            *ngIf="editField !== 'endDate'"
            src="assets/icons/pencil.svg"
            alt="pencil"
            class="ml-[10px] h-[12px] cursor-pointer"
            (click)="handleSelectField('endDate')"
          />
        </div>
        <p
          class="project-attribute-value !mb-[0px]"
          *ngIf="editField !== 'endDate'"
        >
          {{ projectData?.end_date | date : "yyyy-MM-dd" }}
        </p>
      </div>
      <div *ngIf="editField === 'endDate'">
        <app-date
          (onCLose)="onCLose()"
          (onSave)="onSave($event)"
          [date]="projectData?.end_date"
        ></app-date>
      </div>
    </div>

    <div
      class="flex-1 flex flex-col items-start mt-[30px] justify-start w-[100%]"
    >
      <div class="w-[90%]">
        <div class="flex items-center justify-flex-start">
          <div class="w-1/3">
            <p class="milestone-header">Milestones</p>
          </div>
          <div class="w-1/3">
            <p class="milestone-header">From</p>
          </div>
          <div class="w-1/3">
            <p class="milestone-header">To</p>
          </div>
        </div>
      </div>

      <div *ngFor="let milestone of projectData?.mile_stones" class="w-[90%]">
        <div
          class="w-[100%]"
          *ngIf="
            editField !== 'milestone' && milestone.id !== selectedMileStoneId
          "
        >
          <div class="flex items-center justify-flex-start">
            <div class="w-1/3">
              <p class="milestone-value !mb-[10px]">
                {{ milestone?.name }}
              </p>
            </div>
            <div class="w-1/3">
              <p class="milestone-value !mb-[10px]">
                {{ milestone?.start_date }}
              </p>
            </div>
            <div class="w-1/3">
              <p class="milestone-value !mb-[10px] flex justify-start">
                <span> {{ milestone?.end_date }} </span>

                <img
                  *ngIf="editField !== 'milestone'"
                  src="assets/icons/pencil.svg"
                  alt="pencil"
                  class="ml-[10px] h-[12px] cursor-pointer"
                  (click)="
                    handleSelectMileStoneField('milestone', milestone?.id)
                  "
                />
              </p>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            editField === 'milestone' && milestone.id === selectedMileStoneId
          "
        >
          <app-milestone
            (onCLose)="onCLose()"
            (onSave)="onSave($event)"
            [name]="milestone?.name"
            [startDate]="milestone?.start_date"
            [endDate]="milestone?.end_date"
            [projectStartDate]="projectData?.start_date"
            [projectEndDate]="projectData?.end_date"
          ></app-milestone>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-start gap-[50px] w-[100%]">
    <div class="w-[29%] p-[30px] flex justify-start items-start">
      <div class="flex justify-start items-center">
        <div class="key-deliverable">Stakeholders</div>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] h-[12px] cursor-pointer"
          (click)="handleSelectField('stakeholder')"
          *ngIf="editField !== 'stakeholder'"
        />
      </div>
    </div>

    <div class="flex-1 flex flex-col items-start justify-start mt-[30px]">
      <div *ngIf="editField !== 'stakeholder'">
        <div *ngFor="let stakeholder of projectData?.stake_holders">
          <p class="project-attribute1">
            {{ stakeholder?.stake_holder }}
          </p>
        </div>
      </div>
      <div *ngIf="editField === 'stakeholder'">
        <app-stakeholder
          (onSave)="onSave($event)"
          (onCLose)="onCLose()"
          [selectedStakeholders]="projectData?.stake_holders"
          [stakeholders]="stakeholders"
        ></app-stakeholder>
      </div>
    </div>
  </div>

  <app-approval-status-view
    [projectId]="projectId"
    [stage]="PROJECT_STAGE?.STAGE_1"
  ></app-approval-status-view>
</div>
